import React, { useState, useEffect } from "react";

import "./style.css";

import Loading from "../../../../components/Loading";

import { useAlert } from "../../../../context/AlertContext";
import { editarLocalDestino } from "../../../../api/requisicoes/variaveis";

const ModalEditarVariavelDestino = ({
  localDestinoSelecionado,
  setLocalDestinoSelecionado,
  isOpen,
  onClose,
  atualizar,
  setAtualizar,
}) => {
  const [id, setId] = useState("");
  const [localDestino, setLocalDestino] = useState("");

  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  // Atualiza os estados quando localDestinoSelecionado mudar
  useEffect(() => {
    if (localDestinoSelecionado) {
      setId(localDestinoSelecionado.id);
      setLocalDestino(localDestinoSelecionado.localDestination);
    }
  }, [localDestinoSelecionado]);

  const fecharModal = () => {
    setId("");
    setLocalDestino("");
    setLocalDestinoSelecionado("");

    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const localDestinoEditado = {
      id,
      localDestino,
    };

    try {
      setLoading(true);
      await editarLocalDestino(localDestinoEditado);
      showAlert("Local de destino atualizado com sucesso!", "sucesso");
      setAtualizar(!atualizar);
      fecharModal();
    } catch (error) {
      if (error.response) {
        showAlert(`Erro! ${error.response.data.error}.`, "erro");
      } else {
        showAlert(
          "Erro desconhecido, contate o administrador do sistema!",
          "erro"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal">
      {loading && <Loading />} {/* Mostra o carregamento quando necessário */}
      <div className="modal-content-variaveis">
        <h2>Editar variável</h2>
        <div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Local de Destino:</label>
              <input
                type="text"
                id="localDestino"
                name="localDestino"
                value={localDestino}
                onChange={(e) => setLocalDestino(e.target.value)}
                onBlur={(e) => setLocalDestino(e.target.value.toUpperCase())}
                required
              />
            </div>

            <div>
              <button type="submit" id="modalUsuarios-botao-confirmar">
                Confirmar
              </button>
              <button
                id="modalUsuarios-botao-fechar"
                onClick={() => fecharModal()}
              >
                Fechar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalEditarVariavelDestino;
